import { CheckCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { formatCurrency, getCarSaleLabel } from "../../../lib/insuranceSaleApi";
import cn from "../../../../../utilities/tailwind-merge";

const SellableCarCard = ({ car, selected, onSelect }) => {
    const { t } = useTranslation("sellInsurance");
    const carId = car.id ?? car._id;
    const imageUrl = car?.images?.image1;
    const isLinked = car?.insuranceVehicleInfo?.active === true;

    return (
        <button
            type="button"
            aria-pressed={selected}
            onClick={() => onSelect(carId)}
            className={cn(
                "flex w-full min-w-0 items-center gap-3 rounded-xl border p-3 text-left transition-colors",
                selected
                    ? "border-[#5D5DF6] bg-[#F5F5FF] ring-1 ring-[#5D5DF6]"
                    : "border-gray-200 bg-white hover:border-[#5D5DF6]/50 hover:bg-gray-50",
            )}>
            <div className="h-16 w-24 flex-shrink-0 overflow-hidden rounded-lg bg-gray-100">
                {imageUrl ? (
                    <img src={imageUrl} alt={getCarSaleLabel(car)} className="h-full w-full object-cover" />
                ) : (
                    <div className="flex h-full w-full items-center justify-center text-xs text-gray-400">
                        {t("wizard.noCarImage")}
                    </div>
                )}
            </div>

            <div className="min-w-0 flex-1">
                <p className="m-0 truncate text-base font-semibold text-gray-900">{getCarSaleLabel(car)}</p>
                <p className="m-0 mt-0.5 truncate font-mono text-sm text-gray-500">{car?.VIN || "—"}</p>
                <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">
                    <Tag color={isLinked ? "success" : "warning"} className="m-0 rounded-full">
                        {isLinked ? t("wizard.insuranceLinked") : t("wizard.insuranceNotLinked")}
                    </Tag>
                    {car?.worthValue != null ? (
                        <span className="text-sm text-gray-500">
                            {t("wizard.vehicleValue")}: {formatCurrency(car.worthValue)}
                        </span>
                    ) : null}
                </div>
            </div>

            {selected ? <CheckCircleFilled className="flex-shrink-0 text-xl text-[#5D5DF6]" /> : null}
        </button>
    );
};

SellableCarCard.propTypes = {
    car: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
};

SellableCarCard.defaultProps = {
    selected: false,
};

export default SellableCarCard;
